// tela-aplicativo-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Em branco, o app mostra \"Saldo Cashback\".": "Si se deja en blanco, la app muestra \"Saldo Cashback\".",
    "Em branco, o app mostra \"Saldo em Pontos\".": "Si se deja en blanco, la app muestra \"Saldo em Pontos\".",
    "Em branco, o app mostra \"Vales\".": "Si se deja en blanco, la app muestra \"Vales\".",
    "O saldo em cashback só aparece com o valor do cashback para 1 ponto preenchido em Configurações › Geral.": "El saldo en cashback solo aparece si el valor del cashback por 1 punto está completado en Configuración › General.",
    "Tela Resgatar": "Pantalla Canjear",
};

export default catalogo;
